export enum PageReferenceTypeEnum {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
}
